import Vue from 'vue'
import Router from 'vue-router'
import localforage from 'localforage'
import store from '@/store'

import auth from '@app/auth/routes'
import usuarios from '@app/usuarios/usuarios/routes'
import usuariosLog from '@app/usuarios/logs/routes'
import perfis from '@app/usuarios/perfis/routes'
import dashboard from '@app/dashboard/routes'
import clientes from '@app/clientes/clientes/routes'
import comoConheceu from '@app/clientes/como-conheceu/routes'
import fornecedores from '@app/fornecedores/fornecedores/routes'
import financeiroContas from '@app/financeiro/contas/routes'
import financeiroCategorias from '@app/financeiro/categorias/routes'
import financeiroFormas from '@app/financeiro/formas/routes'
import financeiroPagar from '@app/financeiro/pagar/routes'
import financeiroReceber from '@app/financeiro/receber/routes'
import financeiroExtrato from '@app/financeiro/extrato/routes'
import orcamentos from '@app/orcamentos/orcamentos/routes'
import orcamentosPagamento from '@app/orcamentos/pagamentos/routes'
import contatos from '@app/contatos/contatos/routes'
import servicos from '@app/servicos/routes'
import produtos from '@app/produtos/routes'
import estoque from '@app/produtos/estoque/routes'
import equipamentos from '@app/equipamentos/routes'
import os from '@app/os/os/routes'
import tarefas from '@app/tarefas/tarefas/routes'
import marcas from '@app/marcas/routes'
import vendas from '@app/vendas/vendas/routes'
import compras from '@app/compras/compras/routes'
import revisaoTipos from '@app/os/revisao-tipo/routes'
import relatorios from '@app/relatorios/routes'
import viaturas from '@app/viaturas/routes'
import reclamacoes from '@app/reclamacoes/routes'
import motivos from '@app/orcamentos/motivos/routes'
import grupos from '@app/grupos/routes'
import objetivos from '@app/objetivos/routes'
import cargos from '@app/clientes/cargos/routes'
import familias from '@app/familias/routes'
import canais from '@app/canais/routes'
import artes from '@app/artes/routes'
import tiposEstabelecimento from '@app/tipos-estabelecimento/routes'
import atas from '@app/atas/routes'

const routes = [
  ...auth,
  ...usuarios,
  ...usuariosLog,
  ...perfis,
  ...dashboard,
  ...clientes,
  ...comoConheceu,
  ...fornecedores,
  ...financeiroContas,
  ...financeiroCategorias,
  ...financeiroFormas,
  ...financeiroPagar,
  ...financeiroReceber,
  ...financeiroExtrato,
  ...contatos,
  ...servicos,
  ...produtos,
  ...estoque,
  ...orcamentos,
  ...orcamentosPagamento,
  ...equipamentos,
  ...os,
  ...tarefas,
  ...marcas,
  ...vendas,
  ...compras,
  ...revisaoTipos,
  ...relatorios,
  ...viaturas,
  ...reclamacoes,
  ...motivos,
  ...grupos,
  ...objetivos,
  ...cargos,
  ...familias,
  ...artes,
  ...canais,
  ...tiposEstabelecimento,
  ...atas
]

Vue.use(Router)

const router = new Router({
  routes
})

const checkAuth = async (to, from, next) => {
  const token = await localforage.getItem('token')
  const permissoes = await localforage.getItem('permissoes')
  const imagem = await localforage.getItem('imagem')
  store.dispatch('setToken', {token})
  store.dispatch('setPermissoes', {permissoes})
  store.dispatch('setImagem', {imagem})
  if (to.name !== 'auth.index' && to.name !== 'auth.recuperar-senha' && to.name !== 'auth.redefinir-senha' && token === null) {
    next({name: 'auth.index'})
  }
}

router.beforeEach(async (to, from, next) => {
  checkAuth(to, from, next)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js